import React from 'react';
import { siteConfig } from '../../config/site';
import { LinkButton } from '../Button';
type GuideCtaProps = {
  /** `feature` is the fuller treatment used near the top of the results. */
  variant?: 'feature' | 'compact';
};

/**
 * The Free Guide CTA. The PDF URL comes from config/site.ts (`guidePdfUrl`),
 * so it is changed in exactly one place.
 */
export function GuideCta({
  variant = 'feature'
}: GuideCtaProps) {
  const label = 'Download the Free Guide to Your Archetype';
  if (variant === 'compact') {
    return <div className="no-print flex flex-col items-center gap-3 rounded-xl border border-border bg-cream-light px-6 py-7 text-center" data-id="element-32" data-mp="1no6fbl1inul0">
        <p className="text-sm text-ink-light" data-id="element-33" data-mp="1skn2abwzc2wi">
          Keep going with the companion guide to the eight relational archetypes.
        </p>
        <LinkButton href={siteConfig.guidePdfUrl} target="_blank" rel="noopener noreferrer" variant="outline" data-id="element-34" data-mp="zylsgr28sd6g">
          {label}
        </LinkButton>
      </div>;
  }
  return <div className="no-print rounded-xl border border-harbor/25 bg-harbor-pale px-6 py-7 sm:px-8" data-id="element-35" data-mp="hhb1kyi6y265">
      <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-36" data-mp="cj9gk817fss1">
        <div className="max-w-md" data-id="element-37" data-mp="7qgc7l9nemgh">
          <h3 className="font-display text-lg font-semibold text-ink" data-id="element-38" data-mp="7pogmag1woq7">
            Your next step, in writing
          </h3>
          <p className="mt-1.5 text-sm leading-relaxed text-ink-light" data-id="element-39" data-mp="3uxa0e2wwjnsm">
            A short guide to what your archetype means day to day, and what shifts when you can see
            the pattern.
          </p>
        </div>
        <LinkButton href={siteConfig.guidePdfUrl} target="_blank" rel="noopener noreferrer" className="shrink-0 bg-harbor text-cream-light hover:bg-harbor-mid" data-id="element-40" data-mp="3kzm7liiuwqd3">
          {label}
        </LinkButton>
      </div>
    </div>;
}